import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { restoreConsent, trackPageView } from "@/lib/analytics";

/**
 * Reports each route change to GA4.
 *
 * The tag is configured with `send_page_view: false`, because in a single-page
 * app the browser only ever loads one document — without this component GA would
 * record the entry screen and then nothing, and every session would look one
 * screen deep.
 *
 * Renders nothing. Must sit inside <BrowserRouter> for useLocation to work.
 */
export function RouteAnalytics() {
  const location = useLocation();

  // Re-apply a previously granted consent once, before the first page_view.
  useEffect(() => {
    restoreConsent();
  }, []);

  useEffect(() => {
    trackPageView(location.pathname + location.search);
  }, [location.pathname, location.search]);

  return null;
}
